import React from "react";

const AccountLoading = () => {
  return (
    <div className='animate-pulse mx-4'>
      {/* Header skeleton */}
      <div className='pb-5 mb-6 border-b border-gray-200'>
        <div className='h-7 bg-gray-200 rounded w-36 mb-3'></div>
        <div className='h-4 bg-gray-200 rounded w-64 mb-2'></div>
        <div className='h-5 bg-gray-200 rounded-full w-20'></div>
      </div>
      {/* Column labels skeleton */}
      <div className='flex gap-8 mb-6 pb-3 border-b border-gray-200'>
        <div className='h-3 bg-gray-200 rounded w-16'></div>
        <div className='h-3 bg-gray-200 rounded w-16'></div>
        <div className='h-3 bg-gray-200 rounded w-16'></div>
      </div>
      {/* Business card skeleton */}
      <div className='bg-white rounded-lg border border-gray-200 shadow-sm p-4'>
        <div className='flex gap-4'>
          <div className='w-1/4'>
            <div className='rounded-full bg-gray-200 w-32 h-32 mb-4'></div>
            <div className='h-5 bg-gray-200 rounded w-3/4 mb-2'></div>
            <div className='h-4 bg-gray-200 rounded w-1/2 mb-3'></div>
            <div className='h-4 bg-gray-200 rounded w-full mb-2'></div>
            <div className='h-4 bg-gray-200 rounded w-4/5'></div>
          </div>
          <div className='w-3/8'>
            <div className='h-16 bg-gray-200 rounded mb-2'></div>
            <div className='h-16 bg-gray-200 rounded mb-2'></div>
          </div>
          <div className='w-3/8'>
            <div className='h-16 bg-gray-200 rounded mb-2'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountLoading;
